// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import CreatableSelect from "react-select/creatable";
// import privateApi from "../../apis/privateApi";
// import Notification from "../../components/Notification/Notification";
// import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";

// import "./ProgrammeSegmentsCreate.css";

// const ProgrammeSegmentsCreate = () => {
//     const navigate = useNavigate();

//     // -------------------------
//     // FORM STATE
//     // -------------------------
//     const [scope, setScope] = useState(null);
//     const [parentSegment, setParentSegment] = useState(null);
//     const [code, setCode] = useState("");
//     const [description, setDescription] = useState("");
//     const [content, setContent] = useState("");
//     const [remark, setRemark] = useState("");

//     // -------------------------
//     // OPTIONS
//     // -------------------------
//     const [parentOptions, setParentOptions] = useState([]);
//     const scopeOptions = [
//         { value: "state", label: "State" },
//         { value: "lga", label: "LGA" },
//     ];

//     // -------------------------
//     // UI STATE
//     // -------------------------
//     const [loading, setLoading] = useState(false);
//     const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
//     const [confirmOpen, setConfirmOpen] = useState(false);
//     const [confirmToken, setConfirmToken] = useState("");

//     const handleNotificationClose = () =>
//         setNotification(prev => ({ ...prev, show: false }));

//     const generateToken = () =>
//         Math.random().toString(36).substring(2, 8).toUpperCase();

//     // -------------------------
//     // 🔥 LOAD PARENT SEGMENTS BASED ON SCOPE
//     // -------------------------
//     useEffect(() => {
//         if (!scope) {
//             setParentSegment(null);
//             setParentOptions([]);
//             return;
//         }

//         privateApi
//             .get(`/api/programme-segments-create?scope=${scope.value}`)
//             .then(res => {
//                 setParentOptions(
//                     res.data.data.map(s => ({
//                         value: s._id,
//                         label: `${s.description} (${s.code})`,
//                     }))
//                 );
//             })
//             .catch(err => {
//                 setNotification({
//                     show: true,
//                     message: "Failed to load parent programmes.",
//                     type: "error",
//                 });
//             });
//     }, [scope]);

//     // -------------------------
//     // SUBMIT
//     // -------------------------
//     const handleSubmit = e => {
//         e.preventDefault();
//         const token = generateToken();
//         setConfirmToken(token);
//         setConfirmOpen(true);
//     };

//     const handleConfirm = async input => {
//         if (input !== confirmToken) {
//             setNotification({ show: true, message: "Incorrect confirmation code.", type: "error" });
//             setConfirmOpen(false);
//             return;
//         }

//         setConfirmOpen(false);
//         setLoading(true);

//         try {
//             await privateApi.post("/api/programme-segments", {
//                 scope: scope?.value,
//                 parentId: parentSegment?.value || null,
//                 code,
//                 description,
//                 content,
//                 remark,
//             });

//             setNotification({ show: true, message: "Programme segment created successfully.", type: "success" });

//             // FULL RESET
//             setScope(null);
//             setParentSegment(null);
//             setCode("");
//             setDescription("");
//             setContent("");
//             setRemark("");

//         } catch (err) {
//             setNotification({
//                 show: true,
//                 message: err.response?.data?.message || "Failed to create programme segment.",
//                 type: "error",
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleCancel = () => setConfirmOpen(false);

//     return (
//         <div className="create-programme-segment">
//             <h2>Create Programme Segment</h2>

//             <Notification {...notification} onClose={handleNotificationClose} />

//             <form onSubmit={handleSubmit}>
//                 {/* SCOPE */}
//                 <div className="form-group">
//                     <label>Scope</label>
//                     <CreatableSelect
//                         options={scopeOptions}
//                         value={scope}
//                         onChange={setScope}
//                         placeholder="Select Scope"
//                         isClearable
//                         required
//                     />
//                 </div>

//                 {/* PARENT SEGMENT */}
//                 <div className="form-group">
//                     <label>Parent Segment</label>
//                     <CreatableSelect
//                         options={parentOptions}
//                         value={parentSegment}
//                         onChange={setParentSegment}
//                         isDisabled={!scope}
//                         placeholder="Select Parent Segment (optional)"
//                         isClearable
//                     />
//                 </div>

//                 {/* CODE */}
//                 <div className="form-group">
//                     <label>Code</label>
//                     <input
//                         type="text"
//                         value={code}
//                         onChange={e => setCode(e.target.value.toUpperCase())}
//                         placeholder="Enter programme code"
//                         required
//                     />
//                 </div>

//                 {/* DESCRIPTION */}
//                 <div className="form-group">
//                     <label>Description</label>
//                     <input
//                         type="text"
//                         value={description}
//                         onChange={e => setDescription(e.target.value)}
//                         placeholder="Enter programme description"
//                         required
//                     />
//                 </div>

//                 {/* CONTENT */}
//                 <div className="form-group">
//                     <label>Content</label>
//                     <textarea
//                         value={content}
//                         onChange={e => setContent(e.target.value)}
//                         placeholder="Optional content description"
//                     />
//                 </div>

//                 {/* REMARK */}
//                 <div className="form-group">
//                     <label>Remark</label>
//                     <textarea
//                         value={remark}
//                         onChange={e => setRemark(e.target.value)}
//                         placeholder="Optional remark"
//                     />
//                 </div>

//                 <div className="action-buttons">
//                     <button type="submit" disabled={loading}>
//                         {loading ? "Saving..." : "Save"}
//                     </button>
//                     <button type="button" onClick={() => navigate(-1)}>Back</button>
//                 </div>
//             </form>

//             <ConfirmDialog
//                 show={confirmOpen}
//                 token={confirmToken}
//                 action="You are about to create a new programme segment"
//                 onConfirm={handleConfirm}
//                 onCancel={handleCancel}
//             />
//         </div>
//     );
// };

// export default ProgrammeSegmentsCreate;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import privateApi from "../../apis/privateApi";
import Notification from "../../components/Notification/Notification";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import "./ProgrammeSegmentsCreate.css";

const rsStyles = {
    control: (b, s) => ({
        ...b,
        borderColor: s.isFocused ? "#006B3C" : "#D2DDD5",
        boxShadow: s.isFocused ? "0 0 0 3px rgba(0,107,60,.18)" : "none",
        "&:hover": { borderColor: "#006B3C" },
        borderRadius: 6, fontSize: 13, minHeight: 38,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        background: s.isDisabled ? "#E4EBE6" : "#F0F4F1",
        opacity: s.isDisabled ? 0.6 : 1,
    }),
    option: (b, s) => ({
        ...b, fontSize: 13,
        background: s.isSelected ? "#006B3C" : s.isFocused ? "rgba(0,107,60,.07)" : "#fff",
        color: s.isSelected ? "#fff" : "#0E1F14",
    }),
    menu: (b) => ({ ...b, zIndex: 9999, borderRadius: 10, border: "1px solid #D2DDD5", boxShadow: "0 12px 40px rgba(1,45,26,.16)" }),
    menuPortal: (b) => ({ ...b, zIndex: 9999 }),
    placeholder: (b) => ({ ...b, color: "#9BB0A0", fontSize: 13 }),
    singleValue: (b) => ({ ...b, color: "#0E1F14" }),
};

const RSField = ({ label, required, children }) => (
    <div className="sgc-form-group">
        <label className={`sgc-label${required ? " required" : ""}`}>{label}</label>
        <div className="sgc-rs-wrap">{children}</div>
    </div>
);

const ProgrammeSegmentsCreate = () => {
    const navigate = useNavigate();

    const [scope, setScope] = useState(null);
    const [parentSegment, setParentSegment] = useState(null);
    const [code, setCode] = useState("");
    const [description, setDescription] = useState("");
    const [content, setContent] = useState("");
    const [remark, setRemark] = useState("");
    const [parentOptions, setParentOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmToken, setConfirmToken] = useState("");

    const scopeOptions = [
        { value: "state", label: "State" },
        { value: "lga", label: "LGA" },
    ];

    useEffect(() => {
        if (!scope) { setParentSegment(null); setParentOptions([]); return; }
        privateApi.get(`/api/programme-segments-create?scope=${scope.value}`)
            .then(res => {
                setParentOptions(res.data.data.map(s => ({ value: s._id, label: `${s.description} (${s.code})` })));
            })
            .catch(() => setNotification({ show: true, message: "Failed to load parent programmes.", type: "error" }));
    }, [scope]);

    const handleSubmit = e => {
        e.preventDefault();
        const token = Math.random().toString(36).substring(2, 8).toUpperCase();
        setConfirmToken(token); setConfirmOpen(true);
    };

    const handleConfirm = async input => {
        if (input !== confirmToken) {
            setNotification({ show: true, message: "Incorrect confirmation code.", type: "error" });
            setConfirmOpen(false); return;
        }
        setConfirmOpen(false); setLoading(true);
        try {
            await privateApi.post("/api/programme-segments", {
                scope: scope?.value, parentId: parentSegment?.value || null,
                code, description, content, remark,
            });
            setNotification({ show: true, message: "Programme segment created successfully.", type: "success" });
            setScope(null); setParentSegment(null);
            setCode(""); setDescription(""); setContent(""); setRemark("");
        } catch (err) {
            setNotification({ show: true, message: err.response?.data?.message || "Failed to create programme segment.", type: "error" });
        } finally { setLoading(false); }
    };

    return (
        <div className="sgc-page">
            <div className="sgc-card">
                <div className="sgc-card-header">
                    <h2>Create Programme Segment</h2>
                    <p>Add a new node to the programme classification hierarchy</p>
                </div>

                <Notification show={notification.show} message={notification.message}
                    type={notification.type} onClose={() => setNotification(p => ({ ...p, show: false }))} />

                <form className="sgc-form-body" onSubmit={handleSubmit}>
                    <div className="sgc-section-title">Classification</div>

                    <RSField label="Scope" required>
                        <CreatableSelect styles={rsStyles} menuPortalTarget={document.body} menuPosition="fixed"
                            options={scopeOptions} value={scope} onChange={setScope}
                            placeholder="Select scope…" isClearable />
                    </RSField>

                    <RSField label="Parent Segment">
                        <CreatableSelect styles={rsStyles} menuPortalTarget={document.body} menuPosition="fixed"
                            options={parentOptions} value={parentSegment} onChange={setParentSegment}
                            isDisabled={!scope} placeholder="Select parent segment (optional)…" isClearable />
                    </RSField>

                    <div className="sgc-divider" />
                    <div className="sgc-section-title">Segment Details</div>

                    <div className="sgc-form-group">
                        <label className="sgc-label required">Code</label>
                        <input className="sgc-input" type="text" required
                            value={code} onChange={e => setCode(e.target.value.toUpperCase())}
                            placeholder="E.g. P01, P01-01…" />
                    </div>

                    <div className="sgc-form-group">
                        <label className="sgc-label required">Description</label>
                        <input className="sgc-input" type="text" required
                            value={description} onChange={e => setDescription(e.target.value)}
                            placeholder="Enter programme description…" />
                    </div>

                    <div className="sgc-form-group">
                        <label className="sgc-label">Content</label>
                        <textarea className="sgc-textarea"
                            value={content} onChange={e => setContent(e.target.value)}
                            placeholder="Optional content description…" />
                    </div>

                    <div className="sgc-form-group">
                        <label className="sgc-label">Remark</label>
                        <textarea className="sgc-textarea"
                            value={remark} onChange={e => setRemark(e.target.value)}
                            placeholder="Optional remark…" />
                    </div>

                    <div className="sgc-actions">
                        <button type="button" className="sgc-btn sgc-btn-back" onClick={() => navigate(-1)}>← Back</button>
                        <button type="submit" className="sgc-btn sgc-btn-primary" disabled={loading}>
                            {loading ? "Creating…" : "✓ Create Segment"}
                        </button>
                    </div>
                </form>
            </div>

            <ConfirmDialog show={confirmOpen} token={confirmToken}
                action="You are about to create a new programme segment"
                onConfirm={handleConfirm} onCancel={() => setConfirmOpen(false)} />
        </div>
    );
};

export default ProgrammeSegmentsCreate;